import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import UITextComponent from '../../../Component/UI/Text';
import { delay } from '../../../Utility/Task/TaskQueue';

export class Writing extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: any
    ): IterableIterator<number> {
        const component = gameObject.getComponent(UITextComponent);
        const charDelay = meta.duration / meta.message.length;

        component.recalculateBounds(meta.message);

        component.text = '';
        for (const c of meta.message) {
            component.text += c;
            yield* delay(charDelay);
        }
    }
}
